import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { getLeaderboardSagaAction } from "../../../redux/sagaActions";
import { setLeaderboardAction } from "../../../redux/rootReducer";
import CalendarOffline from "../../CalendarOffline/CalendarOffline";

const LeaderboardHeader = () => {
    const dispatch = useDispatch();
    const leaderboard = useSelector(state => state.leaderboard);

    // Состояние календаря
    const [openFromCalendar, setOpenFromCalendar] = useState(false);
    const [openToCalendar, setOpenToCalendar] = useState(false);

    return (
        <>
            <div className="header__dates">
                <div className="flt__box">
                    <div className="flt__title">Начало периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenFromCalendar(!openFromCalendar);
                         } }
                    >{ leaderboard.date_from ? new Date(leaderboard.date_from).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ leaderboard.date_from }
                        handler={ date => {
                            dispatch(setLeaderboardAction({
                                ...leaderboard,
                                date_from: date
                            }));
                            setOpenFromCalendar(false);
                        } }
                        open={ openFromCalendar }
                        close={ () => setOpenFromCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="flt__title">Окончание периода</div>
                    <div className="input input--datepicker"
                         onClick={ event => {
                             event.preventDefault();
                             event.stopPropagation();
                             setOpenToCalendar(!openToCalendar);
                         } }
                    >{ leaderboard.date_to ? new Date(leaderboard.date_to).toLocaleDateString('ru-Ru') : '' }</div>
                    <CalendarOffline
                        date={ leaderboard.date_to }
                        handler={ date => {
                            dispatch(setLeaderboardAction({
                                ...leaderboard,
                                date_to: date
                            }));
                            setOpenToCalendar(false);
                        } }
                        open={ openToCalendar }
                        close={ () => setOpenToCalendar(false) }
                    />
                </div>
                <div className="flt__box">
                    <div className="button button--blue"
                        onClick={ () => dispatch(getLeaderboardSagaAction({
                            date_from: leaderboard.date_from,
                            date_to: leaderboard.date_to
                        })) }
                    >Применить</div>
                </div>
            </div>
        </>
    );
};

export default LeaderboardHeader;